import { makeStyles } from '@mui/styles'
import { alpha } from '@mui/material/styles'

const useStyles = makeStyles(theme => ({
  appBar: {
    background: `linear-gradient(180deg,
    ${theme.palette.neutral.white} 0%,
    ${alpha(theme.palette.neutral.white, 0.733554)} 80%,
    ${alpha(theme.palette.neutral.white, 0)} 100%);`,
    transition: theme.transitions.create(['width', 'margin'], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
    height: theme.spacing(8),
    justifyContent: 'center',
    boxShadow: 'none',

    [theme.breakpoints.up('sm')]: {
      paddingLeft: theme.utils.desktopSidebarWidth.close,
      alignItems: 'flex-end',
    },
  },
  appBarShift: {
    transition: theme.transitions.create('width', {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.enteringScreen,
    }),
    [theme.breakpoints.up('sm')]: {
      width: `calc(100% - ${theme.utils.desktopSidebarWidth.open}px)`,
    },
  },
  logo: {
    display: 'block',
    margin: '0 auto',
    height: theme.spacing(5),
  },
  loading: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    width: theme.spacing(4),
    height: theme.spacing(4),
  },
  toolbar: {
    justifyContent: 'space-between',
  },
  leftGroup: {
    display: 'flex',
    alignItems: 'center',
  },
  userButton: {
    marginRight: theme.spacing(1.5),
    padding: theme.spacing(0.5, 1.5),
    border: 'none',
    color: theme.palette.neutral.dark,

    '& .MuiAvatar-root': {
      marginRight: theme.spacing(1.5),
    },
    '&:hover .MuiButton-endIcon': {
      color: theme.palette.primary.main,
    },
  },
  userIcon: {
    color: theme.palette.primary.dark,
    marginRight: theme.spacing(1),
  },

  userMenu: {
    '& .MuiMenuItem-root': {
      padding: 0,
      '& a': {
        width: '100%',
        padding: theme.spacing(1.25, 2),
        color: 'inherit',
        textDecoration: 'inherit',
      },
    },
  },
}))

export default useStyles
